import { render, staticRenderFns } from "./GovernmentBondDetail.vue?vue&type=template&id=6c46899a&"
import script from "./GovernmentBondDetail.vue?vue&type=script&lang=js&"
export * from "./GovernmentBondDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports